import { PATH_ADD_JOINHOLDER, PATH_JOINHOLDER_CONFIRMATION } from 'constants/uTagConstants/paths';
import cryptoJS from 'crypto-js';
import { recordPage } from 'utilities/uTagging';
import UtagHelper from 'utilities/utagHelper';
import { getGA4EventKeys } from 'utilities/ga4';

export const doTagPage = ({ userProfile, detalleProducto }) => {
    const { recordId, userId, product, promoCode = '', investmentType, docNumber } = userProfile;
    const pathForTag = PATH_ADD_JOINHOLDER;
    const jointHolderAccount = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    const tipoOnboarding = investmentType;
    const pageName = '/onboarding/step2a/addIntervener';
    const custom = {
        ...getGA4EventKeys({
            eventName: 'step_add_intervener',
            pageName,
            processDetail: 'addIntervener',
            onboardingType: investmentType,
            typeHolder: jointHolderAccount.typeHolder,
        }),
        identificadorOnboarding: docNumber ? cryptoJS.SHA256(docNumber).toString() : '',
        processStep: 'step2a',
    };
    recordPage(
        pathForTag,
        recordId,
        userId,
        product,
        detalleProducto,
        promoCode,
        jointHolderAccount,
        '',
        '',
        tipoOnboarding,
        custom
    );

    return pageName;
};

export const doTagPageOtpView = ({ userProfile, products }) => {
    const { docNumber, recordId, userId, product, promoCode = '', investmentType } = userProfile;
    const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
    const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    const pageName = '/onboarding/step2b/confirmationIntervener';
    const custom = {
        ...getGA4EventKeys({
            eventName: 'step_confirmation_intervener',
            pageName: '',
            processDetail: 'confirmationIntervener',
            onboardingType: investmentType,
            typeHolder: JointHolderInfo.typeHolder,
        }),
        identificadorOnboarding: docNumberEncrypted,
        processStep: 'step2b',
    };

    recordPage(
        PATH_JOINHOLDER_CONFIRMATION,
        recordId,
        userId,
        product,
        products.get('productsDescription'),
        promoCode,
        JointHolderInfo,
        '',
        '',
        investmentType,
        custom
    );

    return pageName;
};
